<wiz-hgroup #hgContainer width="100%" verticalAlign="center" [gap]="2">
  <wiz-icon [wizDisabled]="disableLeft()" (click)="panels('left')" class="image-orange" [wizTooltip]="'$.common.leftpanel.$'"
  tooltipPlacement="right">left-panel</wiz-icon>
  
  <!-- si pas dans un group, la tab bar prend toute la largeur du h-group parent et dépasse, voir pourquoi  -->
  <wiz-hgroup [width]="'100%'">
    <wiz-tab-bar #tabBar [width]="'100%'" [wizButtonList]="tabs"></wiz-tab-bar>
  </wiz-hgroup>

  <wiz-icon [wizDisabled]="disableRight()" (click)="panels('right')" class="image-orange" [wizTooltip]="'$.common.rightpanel.$'"
  tooltipPlacement="right">right-panel</wiz-icon>
  
</wiz-hgroup>
